import _styled from '@emotion/styled/base';
import { Spacing } from '../primitives/spacing.js';
import { Spacer } from '../primitives/Spacer/index.js';
import { border } from '@hubble/tokens/web';

const STATUS_THEME_MAP = {
  info: 'informational',
  success: 'positive',
  warning: 'warning',
  alert: 'negative',
  reward: 'reward'
};
const SectionMessageWrapper = _styled(Spacer, {
  target: "e78yi2r0"
})("background-color:", ({
  statusType,
  theme
}) => theme.colorScheme.status.default.background[STATUS_THEME_MAP[statusType]], ";border-radius:", border.radius.lg, ";color:", ({
  theme
}) => theme.colorScheme.content.primary, ";display:grid;grid-template-columns:min-content 1fr;grid-gap:", Spacing.scale[1.5], ";padding:", Spacing.scale[2], ";");

export { SectionMessageWrapper };
